export const MONTHS = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export const DAY_W = 40;
export const LEFT_W = 120;

export const ORIGIN_COLOR = {
  Diretto: "bg-emerald-500",
  Viaggiacolpasta: "bg-sky-500",
  "Dea Maldives": "bg-violet-500",
  "Maldive da vivere": "bg-orange-500",
  "Un'Emozione per Sempre": "bg-rose-500",
};

export const iso = (d) => d.toISOString().slice(0, 10);

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const diffDays = (a, b) => Math.round((new Date(b) - new Date(a)) / 86400000);

// --- Axis helpers: pure ISO-string / UTC math, timezone-independent ---
const WD_SHORT = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];
const _utc = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(Date.UTC(y, m - 1, d)); };

export const addDaysStr = (s, n) => {
  const dt = _utc(s);
  dt.setUTCDate(dt.getUTCDate() + n);
  return dt.toISOString().slice(0, 10);
};
export const dayNum = (s) => Number(s.slice(8, 10));
export const weekdayShortStr = (s) => WD_SHORT[_utc(s).getUTCDay()];
export const isWeekendStr = (s) => { const wd = _utc(s).getUTCDay(); return wd === 0 || wd === 6; };
export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const firstOfMonthStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
};

export const SLANT = 9;

export const barFor = (b, start, numDays) => {
  const off = diffDays(start, b.checkin);
  const nights = Math.max(1, diffDays(b.checkin, b.checkout));
  let startX = (off + 0.5) * DAY_W;            // metà del giorno di check-in (arrivo pomeriggio)
  let endX = (off + nights + 0.5) * DAY_W;     // metà del giorno di check-out (partenza mattina)
  const maxX = numDays * DAY_W;
  if (endX <= 0 || startX >= maxX) return null;
  startX = Math.max(0, startX);
  endX = Math.min(maxX, endX);
  return { left: startX + 1, width: Math.max(10, endX - startX - 2) };
};

export const expandBars = (bookings) =>
  bookings.flatMap((b) => {
    const hasSegs = b.segments && b.segments.length;
    const segs = hasSegs
      ? b.segments
      : [{ property_id: b.property_id, checkin: b.checkin, checkout: b.checkout }];
    return segs
      .filter((s) => s.property_id && s.checkin && s.checkout)
      .map((s, i) => ({
        booking: b,
        key: `${b.id}-${i}`,
        property_id: s.property_id,
        checkin: s.checkin,
        checkout: s.checkout,
        isSegment: !!hasSegs,
      }));
  });

export const STATUS_LEGEND = [
  ["Opzionata", "bg-sky-400"],
  ["Confermata · da incassare", "bg-orange-500"],
  ["Confermata · acconto", "bg-amber-400"],
  ["Confermata · saldato", "bg-emerald-500"],
  ["Passata", "bg-slate-400"],
];

export const barColor = (b, isPast) => {
  if (isPast) return "bg-slate-400";
  if (b.status === "opzionata") return "bg-sky-400";
  const ps = b.payment_status || "none";
  if (ps === "full") return "bg-emerald-500";
  if (ps === "partial") return "bg-amber-400";
  return "bg-orange-500";
};
